import PaymentOptionsLoadingStatus from '../../../../enums/PaymentOptionsLoadingStatus';
import Track from '../../../utils/tracking';
import * as CheckoutAPIActions from '../../APIActions/CheckoutAPIActions';
import setPaymentOptionsLoadingStatus from '../setPaymentOptionsLoadingStatus';
import setAdyenV2SessionData from './setAdyenV2SessionData';

export default function getSessionDataForAdyenV2() {
  return (dispatch) => {
    dispatch(setPaymentOptionsLoadingStatus(PaymentOptionsLoadingStatus.LOADING));
    return dispatch(CheckoutAPIActions.getSessionDataForAdyenV2())
      .then((adyenV2SessionResponse) => {
        if (adyenV2SessionResponse.status === 200 && adyenV2SessionResponse.msg) {
          dispatch(setAdyenV2SessionData(adyenV2SessionResponse.msg));
        } else {
          Track.error(`Error getting Adyen V2 session data from Checkout API: response: ${JSON.stringify(adyenV2SessionResponse)}`);
          dispatch(setPaymentOptionsLoadingStatus(PaymentOptionsLoadingStatus.ERROR));
        }
      })
      .catch((e) => {
        Track.error(`Error setting Adyen V2 session data: ${e}`);
        dispatch(setPaymentOptionsLoadingStatus(PaymentOptionsLoadingStatus.ERROR));
      });
  };
}
